export default __webpack_public_path__ + "static/media/5.778e513a.jpg";